import { FileboyClient } from "@cd2/fileboy-react"
import { getFileboyGlobalConfig } from "./utils"
import { triggerUploadModal } from "./uploader"
import {
  setUpGlobalInputs,
  setUpGlobalVideoPlayers,
  setUpSpecificVideoPlayers,
} from "./globalElements"

export let client: FileboyClient

export { triggerUploadModal }

onLoad(() => {
  console.log("on load")

  const config = getFileboyGlobalConfig()
  console.log("Loaded config", config)
  client = new FileboyClient(config)
  setUpGlobalInputs(config)
  setUpGlobalVideoPlayers(config)
  ;(window as any).fb = {
    reloadVideoPlayers: () => {
      setUpGlobalVideoPlayers(config)
    },
    reloadInputs: () => {
      setUpGlobalInputs(config)
    },
    loadPlayer(element: HTMLElement) {
      setUpSpecificVideoPlayers(config, element)
    },
  }
})

function onLoad(cb: () => void) {
  const readyState: string = document.readyState
  if (readyState === "complete" || readyState === "loaded") {
    cb()
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      cb()
    })
  }
}
